/**
 * @generated SignedSource<<c80bc3be36fc03823f80a6c162b1a50d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SingleSelectColumnProject$data = {
  readonly columns: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"SingleSelectColumn">;
      } | null;
    } | null> | null;
  };
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "SingleSelectColumnProject";
};
export type SingleSelectColumnProject$key = {
  readonly " $data"?: SingleSelectColumnProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"SingleSelectColumnProject">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SingleSelectColumnProject",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10
        }
      ],
      "concreteType": "ProjectColumnConnection",
      "kind": "LinkedField",
      "name": "columns",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectColumnEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectColumn",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "SingleSelectColumn",
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/)
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "columns(first:10)"
    }
  ],
  "type": "Project",
  "abstractKey": null
};
})();

(node as any).hash = "cafb82cd33741237d1cc64381274945c";

export default node;
